import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';

@Injectable()
export class CategoriaCNHRepository extends BaseRepository {
    constructor(http: HttpClient) {
        super(http, environment.serverAuthUrl, ApiResources.CATEGORIA);
    }

    filter(search: string) {
        return this.getRequest<{ data: { results: any[]; count: number } }>({
            search,
            page: 1,
            offset: 0,
            limit: 10,
        }).pipe(
            map(({ data }) =>
                data.results.map((item) => ({
                    label: String(item.sigla),
                    value: String(item.id),
                })),
            ),
        );
    }
}
